module.exports = __webpack_public_path__ + "media/images/icons/clock-dark-d358d0e0d2992bcd4c24f0bbbc974f31.svg";